import { render, staticRenderFns } from "./rechargeAddModel.vue?vue&type=template&id=13c2f733&scoped=true&"
import script from "./rechargeAddModel.vue?vue&type=script&lang=js&"
export * from "./rechargeAddModel.vue?vue&type=script&lang=js&"
import style0 from "./rechargeAddModel.vue?vue&type=style&index=0&id=13c2f733&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c2f733",
  null
  
)

export default component.exports